import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { TenantProvider } from './context/TenantContext';
import { ThemeProvider } from './context/ThemeContext';
import './index.css';
/* ⓘ La liste des routes publiques, lue depuis le point unique. */
import { CHEMINS_PUBLICS } from './seo/pages';

// Fermer les modaux avec Echap
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    const overlay = document.querySelector('.gss-modal-overlay');
    if (overlay) overlay.click();
  }
});

/* ═══════════════════════════════════════════════════════════════════════════
 * HYDRATER PLUTÔT QUE REMPLACER — lot visibilité, 14/10/2026
 * ═══════════════════════════════════════════════════════════════════════════
 * ⚠️ C'EST CETTE LIGNE QUI SUPPRIME LE FLASH. Les six pages publiques sont
 *    pré-rendues en HTML statique au build : `#root` arrive DÉJÀ REMPLI. Avec
 *    `createRoot`, React **efface** ce contenu et le redessine — le visiteur
 *    voit la page, puis un blanc, puis la page. Avec `hydrateRoot`, il
 *    s'attache au DOM existant : rien n'est effacé, rien ne clignote.
 * ⓘ LE CHOIX EST FAIT SUR L'ÉTAT RÉEL DU CONTENEUR, pas sur une variable
 *   d'environnement : l'application connectée n'est pas pré-rendue, son `#root`
 *   est vide, et elle prend `createRoot` — sans qu'on ait à le lui dire.
 * ⚠️ UN ÉCART ENTRE LE HTML PRÉ-RENDU ET LE PREMIER RENDU CLIENT N'EST PAS UNE
 *    PANNE : React corrige et avertit en console. Mais c'est le flash qui
 *    revient. La recette compare donc les captures AVANT et APRÈS hydratation.
 * ═══════════════════════════════════════════════════════════════════════════ */
const conteneur = document.getElementById('root');

/* ═══════════════════════════════════════════════════════════════════════════
 * 🔴 CETTE GARDE N'EST PLUS LA PROTECTION — ELLE EST LA SECONDE — 16/10/2026
 * ═══════════════════════════════════════════════════════════════════════════
 * ⚠️ CE QU'ELLE NE POUVAIT PAS FAIRE, ET QUI A FAIT RETIRER LE LOT DEUX FOIS.
 *    Elle vide bien le conteneur quand le HTML reçu ne correspond pas à la
 *    route — mais elle ne tourne qu'**une fois le bundle chargé et exécuté**.
 *    Mesuré en production le 16/10 : bundle de 1,99 Mo, React prend la main à
 *    **5 à 6 secondes**. Pendant ces cinq secondes, ce que l'œil voit est le
 *    HTML SERVI, et c'était la vitrine. *Une garde en JavaScript ne peut rien
 *    contre ce que le serveur a déjà envoyé.*
 * ➡️ LA PROTECTION EST DÉSORMAIS DANS CE QUI EST SERVI : les routes
 *    d'application reçoivent `app.html`, coquille au `#root` vide, sans un mot
 *    de vitrine (voir `frontend/scripts/prerendre.js` et `ops/nginx/`).
 * ⓘ CETTE LIGNE RESTE, et elle n'est pas de la décoration : si un jour une
 *   règle Nginx repart en arrière, elle évite que React tente d'hydrater la
 *   vitrine sur un écran de travail. Elle ne rattrape pas l'affichage ; elle
 *   rattrape l'incohérence. *La protection qui compte est celle qui agit avant
 *   que le visiteur ne voie quoi que ce soit.*
 * ═══════════════════════════════════════════════════════════════════════════ */
const CHEMINS_PRE_RENDUS = CHEMINS_PUBLICS;
const cheminActuel = window.location.pathname.length > 1
  ? window.location.pathname.replace(/\/+$/, '') : window.location.pathname;
const surPagePublique = CHEMINS_PRE_RENDUS.includes(cheminActuel);
const estPreRendu = conteneur.hasChildNodes() && surPagePublique;
if (conteneur.hasChildNodes() && !surPagePublique) conteneur.innerHTML = '';
const arbre = (
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <TenantProvider>
            <App />
          </TenantProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);

if (estPreRendu) {
  ReactDOM.hydrateRoot(conteneur, arbre);
} else {
  ReactDOM.createRoot(conteneur).render(arbre);
}
